import styles from './App.css'
import { Header } from './Header/'
import { Body } from './Body/'
import { connect } from '../../lib/provider'
import { Footer } from './Footer'
import { Part } from './Body/Part'
import { Kloster } from './Body/Kloster'
import { Doc } from '../types'
import * as preact from 'preact'

const { h, Component } = preact

interface Props {
  doc: Doc;
  sendGaEvent: (event: Object) => void;
}

interface State {
  klosterActive: boolean;
  headerActive: boolean;
}

class _App extends Component<Props, State> {
  constructor() {
    super()
    this.state = {
      klosterActive: false,
      headerActive: false
    }
  }

  intersectionObserver = undefined
  kloster = undefined
  header = undefined

  componentDidMount() {
    this.intersectionObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (entry.target === this.kloster.wrapper) {
            this.setState({ klosterActive: true })
          } else if (entry.target === this.header.el) {
            this.setState({ headerActive: true })
          }
        } else {
          if (entry.target === this.kloster.wrapper) {
            this.setState({ klosterActive: false })
          } else if (entry.target === this.header.el) {
            this.setState({ headerActive: false })
          }
        }
      })
    })
    this.intersectionObserver.observe(this.kloster.wrapper)
    this.intersectionObserver.observe(this.header.el)
  }

  componentWillUnmount() {
    this.intersectionObserver.unobserve(this.kloster.wrapper)
    this.intersectionObserver.unobserve(this.header.el)

    // Disconnect intersection observer
    this.intersectionObserver.disconnect()
  }

  render() {
    return (
      <div class={styles.app}>
        <script src="https://static.nrk.no/core-masthead/major/1/core-masthead.html.js" />
        <Header
          ingress={this.props.doc.ingress}
          ref={el => (this.header = el)}
          visible={this.state.headerActive}
        />
        <Body>
          <Part part={this.props.doc['part-1']} />
          <Kloster visible={this.state.klosterActive} ref={el => (this.kloster = el)} />
          <Part part={this.props.doc['part-2']} />
          <Part part={this.props.doc['part-3']} />
        </Body>
        <Footer />
      </div>
    )
  }
}

export const App = connect()(_App)



// WEBPACK FOOTER //
// ./src/v1/components/App.tsx